import DefaultCostEstimateDetailView from "src/components/feature/CostEstiamteDetails";

const CostEstimateDetails = () => {
  return <DefaultCostEstimateDetailView />;
};

export default CostEstimateDetails;
